import { EVENT } from "@/constants/event";
import useAppStore from "@/context/store";
import getNextDetailsSetp, {
  getNextViewImageSetp,
} from "@/utils/getHistorySetp";
import { useEventListener, useMount } from "ahooks";
import { Modal } from "antd";
import qs from "qs";
import { useCallback, useMemo } from "react";
import ModalWrap from "../HBModal/ModalWrap";
import ImageViewer from "./imageViewer";
import styles from "./index.module.less";
/**
 * - 这是一个全局查看大图弹窗
 * - 可以通过modalImg字段触发
 */
function HBImagePreviewModal() {
  const { currentPreview } = useAppStore(({ currentPreview }) => ({
    currentPreview,
  }));

  useMount(async () => {
    let { modalImg } = qs.parse(location.search.slice(1));
    if (modalImg) {
      setPinInfo(modalImg);
    }
  });
  // 监听浏览器前进回退
  useEventListener("popstate", async () => {
    // 判断当前的查看大图弹窗是否被打开
    let { modalImg } = qs.parse(location.search.slice(1));
    setPinInfo(modalImg);
  });

  // 监听弹窗关闭自定义事件
  useEventListener(EVENT.MODAL_PREVIEW_CLOSE, async () => {
    useAppStore.setState({ currentPreview: {} });
  });

  const { src, preview, pinFile } = useMemo(() => {
    // 如果有图片则直接展示图片url
    let { src, preview, pinFile } = currentPreview;
    // 不支持的图片格式
    return { src, preview, pinFile };
  }, [currentPreview]);

  const setPinInfo = (url) => {
    // 如果有url，则不需要调接口
    if (url) {
      useAppStore.setState({ currentPreview: { src: url } });
      return;
    }
    useAppStore.setState({ currentPreview: {} });
  };
  const onClick = useCallback((e) => {
    if (e.target !== e.currentTarget) {
      return false;
    }
    onClose();
  }, []);
  // 关闭弹窗
  const onClose = () => {
    // 重置currentPreview 数据
    useAppStore.setState({ currentPreview: {} });
    // 修改当前url
    const query = qs.parse("");
    delete query.modalImg;
    let detailsSetp = getNextDetailsSetp();

    let viewImageSetp = getNextViewImageSetp();
    // 判断用户有没有切换回原点
    let firstPinId = history?.state?.firstPinId;
    let historyData = typeof history?.state === "object" ? history?.state : {};
    history.pushState(
      {
        ...historyData,
        detailsSetp,
        ...(location.pathname.includes(firstPinId) ? { viewImageSetp } : null),
      },
      null,
      `${location.pathname}${
        qs.stringify(query) ? `?${qs.stringify(query)}` : ""
      }`
    );
  };
  return (
    <Modal
      visible={!!src}
      onOk={onClose}
      onCancel={onClose}
      width="100%"
      footer={null}
      className={styles.modal}
      maskTransitionName=""
      transitionName=""
      destroyOnClose
    >
      <div className={styles.mask} onClick={onClose}></div>
      <ImageViewer
        src={src}
        preview={preview}
        file={pinFile}
        onClick={onClick}
      />
    </Modal>
  );
}

export default ModalWrap(HBImagePreviewModal);
